// extracted by mini-css-extract-plugin
export default {"wrapper":"textarea_wrapper__HpSeq","input":"textarea_input__fHZbC"};